import { FC, useCallback } from "react"
import { GooglePlace, LoanOfficer } from "../../../../types"
import Input from "../../form/input"
import AddressAutocomplete from "../../address-autocomplete"

interface Props {
  title: string
  values: LoanOfficer
  setFormField: (name: string, value: string | string[]) => void
}

const SocialSection: FC<Props> = ({ title, values, setFormField }) => {
  const handleChangeGooglePlace = useCallback(
    (value: GooglePlace | undefined) =>
      setFormField("google_place_id", value?.place_id ?? ""),
    [setFormField]
  )
  return (
    <div className="px-6">
      <h4 className="text-xl font-bold text-primary-alt-400 ">{title}</h4>
      <div className="grid gap-y-6 gap-x-8 grid-cols-12 pt-8">
        <div className="col-span-12">
          <Input label="Facebook profile" name="facebook_link" type="url" />
        </div>
        <div className="col-span-12">
          <Input label="Linkedin profile" name="linkedin_link" type="url" />
        </div>
        <div className="col-span-12">
          <Input label="Calendly profile" name="calendar_link" type="url" />
        </div>
        <div className="col-span-12">
          <Input label="Instagram profile" name="instagram_link" type="url" />
        </div>
        <div className="col-span-12">
          <Input label="YouTube video" name="youtube_link" type="url" />
        </div>
        <div className="col-span-12">
          <Input label="Website" name="website_link" type="url" />
        </div>
        <div className="col-span-12">
          <Input
            label="Special disclosure link"
            name="special_disclosure_link"
            type="url"
          />
        </div>
        <div className="col-span-12">
          <AddressAutocomplete
            label="Connect Google reviews of LO"
            name="google_place_id"
            placeholder="Search google reviews of brand"
            initialValue={values?.google_place_id}
            onChange={handleChangeGooglePlace}
          />
        </div>
        <div className="col-span-12">
          <Input
            label="Connect BirdEye reviews of LO"
            name="birdeye_id"
            placeholder="BirdEye business ID"
          />
        </div>
      </div>
    </div>
  )
}

export default SocialSection
